import { MRT_ColumnDef } from "material-react-table";
import { Job } from "../../../../api";
import { ColumnContext, selectColumn } from "./ColumnHelpers";
import { getJobPriorities, JobsPriority } from "../../../../utilities/types";

export function column_FieldPriority(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return selectColumn<string>(context, "fieldPriority", "fieldPriority", {
		freeSolo: false,
		options: [...getJobPriorities()],
		size: 250,
		hasGroupUpdate: false, // Group updates don't make sense for priority
		getValue: (job) => job.fieldPriority || "Regular Turn (default)",
		setValue: (job, value) => {
			job.fieldPriority = (value || "Regular Turn (default)") as JobsPriority;
		},
	});
}
